// extracted by mini-css-extract-plugin
export default {"root":"IconHelp_root__HWdNp"};